export default __webpack_public_path__ + "static/media/edital15-aprovados.3aa5b754.pdf";